import { render } from "./P027.vue?vue&type=template&id=7de441c3&scoped=true"
import script from "./P027.vue?vue&type=script&lang=js"
export * from "./P027.vue?vue&type=script&lang=js"

import "./P027.vue?vue&type=style&index=0&id=7de441c3&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de441c3"]])

export default __exports__